<template>
    <div>
        <portal to="buttons">

        </portal>

        <b-card no-body>
            <data-table ref="dataTable" url="/api/users" :columns="columns" :filter.sync="filter" create="/users/create" cache-search="tableUsers">
                <!--<template #filter>
                    <v-select v-model="filter.status"
                              :options="statusOptions"
                              class="invoice-filter-select"
                              placeholder="Select Status">
                        <template #selected-option="{ label }">
                            <span class="text-truncate overflow-hidden">
                                {{ label }}
                            </span>
                        </template>
                    </v-select>
                </template>-->
                            <!--<template #create>
                    <b-button variant="primary" to="/test">
                        Opret ny
                    </b-button>
                </template>-->


                <template #Name="data">
                    <b-link :to="data.item.Id" append>{{data.value}}</b-link>
                </template>

                <template #Email="data">
                    {{data.value}}
                </template>

                <template #CreateDate="data">
                    <span class="text-nowrap">
                        {{ $moment(data.value).format("DD. MMM YYYY") }}
                    </span>
                </template>

                <template #actions="data">
                    <div class="text-nowrap">
                        <b-link :to="{ name: 'user', params: { id: data.item.Id } }">
                            <feather-icon icon="EditIcon"
                                          size="16"
                                          class="mx-6 my-2" />
                        </b-link>

                        <b-button @click="deleteUser(data.item)" variant="link" class="p-0">
                            <feather-icon icon="TrashIcon"
                                          size="16"
                                          class="mx-6 my-2" />
                        </b-button>

                    </div>
                </template>

            </data-table>

        </b-card>
    </div>
</template>

<script>
    import DataTable from "@/components/DataTable.vue"
    import Toast from '@/components/_toast.vue'

    export default {
        components: {
            DataTable
        },
        data: () => ({
            filter: {},
            columns: [
                //{ key: 'id', label: '#', sortable: true },
                { key: 'Name', label: 'Navn', sortable: true, stickyColumn: false },
                { key: 'Email', label: 'E-mail', sortable: true },
                { key: 'CreateDate', label: 'Oprettet', sortable: true },
                { key: 'actions', label: '', class: "text-right" },
            ],
            //statusOptions: [
            //    'Downloaded',
            //    'Draft',
            //    'Paid',
            //    'Partial Payment',
            //    'Past Due',
            //],
        }),
        computed: {},
        created() { },
        mounted() { },
        methods: {
            deleteUser(item) {
                this.$swal({
                    title: 'Er du sikker?',
                    text: "Dette sletter " + item.Name,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Jeg er sikker',
                    cancelButtonText: 'Fortryd',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-7',
                    },
                    buttonsStyling: false,
                }).then(result => {
                    if (result.value) {
                        this.$http.post("/api/users/delete/" + item.Id).then(x => {
                            this.$toast({
                                component: Toast,
                                props: {
                                    title: x.data,
                                    icon: 'CheckCircleIcon',
                                    variant: 'success',
                                },
                            })

                            this.$refs.dataTable.refresh()
                        }).catch(x => {
                            this.$toast({
                                component: Toast,
                                props: {
                                    title: x.data,
                                    icon: 'AlertTriangleIcon',
                                    variant: 'danger',
                                },
                            })
                        })

                    } else if (result.dismiss === 'cancel') {


                    }
                })
            }
        },
    }
</script>